import { useApi } from "./useApi";
import { web } from "../lib/api";
import { ymd } from "../lib/recurrence";

/** Monday of the viewer's current week (YYYY-MM-DD). */
export const thisMonday = () => {
  const d = new Date();
  d.setDate(d.getDate() - ((d.getDay() + 6) % 7));
  return ymd(d);
};

/** First day of the school-year season (Aug 1) that today falls in, e.g. 2026-08-01. */
export const seasonStart = () => {
  const d = new Date();
  return `${d.getMonth() >= 7 ? d.getFullYear() : d.getFullYear() - 1}-08-01`;
};

/** {current: {varsity, jv}, counts: {player_id: n}, history, season, reload}. */
export function useCWeek(tid) {
  const q = useApi(tid && `/teams/${tid}/c-of-week?week=${thisMonday()}&since=${seasonStart()}`, web);
  const d = q.data ?? {};
  return { current: d.current ?? {}, counts: d.counts ?? {}, history: Array.isArray(d.history) ? d.history : [], season: Array.isArray(d.season) ? d.season : [], reload: q.reload, loading: q.loading };
}

/** What a player's card shows: this week's C (if they won) and their career award count. */
export const cWeekFor = (cw, pid) => {
  const won = Object.values(cw.current ?? {}).find((a) => a?.player_id === pid);
  const count = cw.counts?.[pid] ?? 0;
  return count ? { current: won?.c_name ?? null, count } : null;
};
